import { render } from "./PAddBlock.vue?vue&type=template&id=cbf6e8e0"
import script from "./PAddBlock.vue?vue&type=script&lang=js"
export * from "./PAddBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__